import { CheckInRuleResponseStatus, Purchase } from "types";

export const getDummyPurchase = () => {
    return {
        id: "PURCHASE_ID",
        object: "purchase",
        status: "committed",
        source: "office",
        dueNow: 0,
        customerName: "John Doe",
        customerEmail: "johndoe@example.com",
        phone: "",
        currency: "USD",
        amount: 50,
        balance: 0,
        items: [
            {
                id: "641da23f01d2ea0b6b4b58b5",
                amount: 50,
                object: "scheduled_experience_purchase_item",
                name: "Rainbow 1",
                status: "confirmed",
                source: "office",
                quantity: 1,
                product: {
                    id: "641da1ce01d2ea0b4e2f7032",
                },
                purchase: {
                    id: "641da23f01d2ea0b6b4b58b4",
                },
                ticketCode: "dzcr7vnf04gk",
                shortCode: "111804",
                guests: [
                    {
                        id: "641da23f01d2ea0b6b4b5896",
                        name: "Adults #1",
                        unit: {
                            id: "UNIT_ID",
                            object: "unit",
                            type: "demographic",
                            visible: true,
                            name: "Adults",
                            sku: "adult",
                            internalName: "adults",
                            description: "Above 18 yrs",
                        },
                        ticketCode: "40ms464hy728",
                        primary: true,
                        guestStatus: "arrived",
                        ticketPrintStatus: {
                            checkInRuleResponses: [
                                {
                                    name: "21+",
                                    status: CheckInRuleResponseStatus.PASS,
                                    showOnTicket: true,
                                    passText: "Adult",
                                    failText: "Underage",
                                },
                                {
                                    name: "Special Discount",
                                    status: CheckInRuleResponseStatus.FAIL,
                                    showOnTicket: true,
                                    passText: "Special",
                                    failText: "Regular",
                                },
                            ],
                        },
                    },
                ],
                tickets: [
                    {
                        type: "xola",
                        ticketCode: "dzcr7vnf04gk",
                    },
                ],
                arrivalDate: "2023-03-24",
                privacy: "public",
                duration: 1,
                arrivalTime: 900,
                arrivalDateTime: "2023-03-24T09:00:00-04:00",
            },
        ],
    } as unknown as Purchase;
};
